import { createAsyncThunk } from '@reduxjs/toolkit';
import { _reportUrls } from '@custom/Utils/constants/apiUrls';

const discardReportApi = createAsyncThunk('discardReportApi', async (body:any) => {
  try {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    let url = `${_reportUrls.deleteReport}`;
    let response = await fetch(url, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ reportId: body }),
    })
    return await response.json()
  } catch (error) {
    return error;
  }
});

export default discardReportApi;
